import { Layout } from 'components/Layout/Layout';
import CMSPage from 'components/PageWrapper/PageWrapper';
import withApollo from 'lib/apollo';
import * as React from 'react';
import { PublicCMSLayout } from '../components/Layout/PublicCMSLayout';

function AboutPage() {
  return (
    <Layout classNames={['h-background--navy-200']} title="About">
      <PublicCMSLayout>
        <CMSPage title="About" pageUrl="about" />
      </PublicCMSLayout>
    </Layout>
  );
}

export default withApollo(AboutPage, { useTemporaryToken: true });
